import api from '@/api/axiosApi'
import type {
  SavedReportFilterCreate,
  SavedReportFilterListResponse,
  SavedReportFilterRead,
} from '@/types/reportFilters'

const MAX_PAGE_SIZE = 200

export async function fetchReportFilters(
  planId: string,
  reportType: string
): Promise<SavedReportFilterRead[]> {
  const { data } = await api.get<SavedReportFilterListResponse>(
    `/plans/${planId}/report-filters`,
    { params: { report_type: reportType, limit: MAX_PAGE_SIZE } }
  )
  return data.data
}

export async function createReportFilter(
  planId: string,
  payload: SavedReportFilterCreate
): Promise<SavedReportFilterRead> {
  const { data } = await api.post<SavedReportFilterRead>(
    `/plans/${planId}/report-filters`,
    payload
  )
  return data
}

export async function deleteReportFilter(
  planId: string,
  filterId: string
): Promise<void> {
  await api.delete(`/plans/${planId}/report-filters/${filterId}`)
}
